import heroAshp from "@/assets/air-source-heat-pumps/hero-ashp.jpg.asset.json";
import heroDamp from "@/assets/damp-survey/hero-house-1600.webp";
import heroIwi from "@/assets/internal-wall-insulation/hero-iwi.jpg.asset.json";
import heroBoilers from "@/assets/lp/boiler/boiler-hero.webp";
import ventHero from "@/assets/lp/ventilation/vent-hero-1280w.webp";
import heroLoft from "@/assets/loft-insulation/hero-loft.jpg.asset.json";
import controlsHero from "@/assets/heating-controls/controls-hero.webp";
import heroWallTies from "@/assets/remedial-wall-ties/walltie-hero.webp";
import { getRasterImage } from "@/generated/raster-images";

/** Hero image URLs for depth-2 main service pages (og:image metadata). */
export const SERVICE_PAGE_OG_IMAGES: Record<string, string> = {
  "/air-source-heat-pumps": heroAshp.url,
  "/solar-pv": getRasterImage("solar-pv/hero-solar").fallback,
  "/loft-insulation": heroLoft.url,
  "/boilers-heating": heroBoilers,
  "/heating-controls": controlsHero,
  "/ventilation-extraction": ventHero,
  "/remedial-wall-ties": heroWallTies,
  "/internal-wall-insulation": heroIwi.url,
  "/boiler-upgrade-scheme": heroAshp.url,
  "/financing": heroLoft.url,
  "/damp-survey": heroDamp,
};
